import { render, staticRenderFns } from "./Literaturschweiz.vue?vue&type=template&id=987cbb5a&"
import script from "./Literaturschweiz.vue?vue&type=script&lang=js&"
export * from "./Literaturschweiz.vue?vue&type=script&lang=js&"
import style0 from "./Literaturschweiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Literaturschweiz.vue"
export default component.exports